export default function request2APIParams(request) {
  const params = new URL(request.url).searchParams;
  const result = {};
  const map = { show: "state" };

  // eslint-disable-next-line array-callback-return
  Array.from(params.entries()).map(([key, value]) => {
    let values = key === "show" ? value.split(",") : [value];
    const _key = key in map ? map[key] : key;
    // eslint-disable-next-line array-callback-return
    values.map((_value) => {
      if (_key in result) {
        if (Array.isArray(result[_key])) {
          result[_key].push(_value);
        } else {
          result[_key] = [result[_key], _value];
        }
      } else {
        result[_key] = _value;
      }
    });
  });
  return result;
}

